
import {ModelBase} from './modelBase'

export class OrganisationBase extends ModelBase {
    organisationId: string;
}